import { graphql } from "gql.tada";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";

export const GetBlogHomepageById = graphql(
  `
    query GetBlogPageById(
      $id: String!,
      $locale: String,
      $preview: Boolean
    ) {
      blogHomepage(
        id: $id,
        preview: $preview,
        locale: $locale
      ) {
        __typename
        # markets
        showPageInLocales
        hero {
          sys { id }
          variant
          title
          subtitle
          description
          ctaText
          ctaLink
          backgroundImage { url contentType }
          overlayImage { url }
          previewVideo { url contentType }
          fullVideo { url contentType }
          fullWidthImage { url contentType }
          eyebrowImagesCollection {
            items { url contentType }
          }
          bodyRichText { ...RichEntryFragment }
        }
        featuredStory {
          sys { id, firstPublishedAt }
          slug
          postTitle
          postSummary
          postTldr
          heroImage {
            ...AccessibleMediaFragment
          }
        }
        ctaFooter {
          sys { id }
          variant
          isVertical
          title
          titleRichText { json }
          cta { ...LinkFragment }
          backgroundImage { url title }
        }
        slug
        navigationAccessibilityLabel
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
      }
    }
  `,
  [
    ThemeFragment,
    MetadataFragment,
    RichEntryFragment,
    LinkFragment,
  ]
);
